"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _popoverController = _interopRequireDefault(require("../_popover-controller"));

var _popoverBody = _interopRequireDefault(require("../_popover-body"));

var _refObject = _interopRequireDefault(require("./../_prop-types/ref-object"));

var TimePickerInvalidPopover = function TimePickerInvalidPopover(props) {
  var inputRef = props.inputRef,
      children = props.children,
      open = props.open,
      t = props.t;
  var anchorNode = inputRef.current ? inputRef.current.parentNode.parentNode.parentNode.parentNode.querySelector("[mdn-input-box-suffix]") : undefined;
  return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
    open: open,
    anchorNode: anchorNode,
    anchorOrigin: "center right",
    popoverOrigin: "bottom center",
    offsetVertical: -18,
    offsetHorizontal: -10
  }, function (_ref) {
    var popoverStyle = _ref.popoverStyle;
    return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], {
      className: popoverStyle,
      type: "fill",
      spacingInset: "small",
      zIndex: t("errorTooltipElevation"),
      arrowAlignment: "center",
      arrowPosition: "bottom"
    }, children);
  });
};

TimePickerInvalidPopover.displayName = "TimePickerInvalidPopover";
TimePickerInvalidPopover.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  inputRef: _refObject["default"].isRequired,
  open: _propTypes["default"].bool.isRequired,
  t: _propTypes["default"].func.isRequired
} : {};
var _default = TimePickerInvalidPopover;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/time-picker/time-picker-invalid-popover.js
// module id = 885
// module chunks = 0